import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getApi } from "../../../api/api";
import { selectCurrentUser } from "../../../store/slices/currentUserSlice";

interface Params {
  itemId: number;
  isFavorite: boolean;
  onChange?: (itemId: number, isActive: boolean) => void;
}

export const useFavoriteButton = ({ itemId, isFavorite, onChange }: Params) => {
  const api = getApi();
  const currentUser = useSelector(selectCurrentUser);
  const isAuthorized = !!currentUser?.id;

  const [active, setActive] = useState(isFavorite);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setActive(isFavorite);
  }, [isFavorite]);

  const handleClick = useCallback(
    async (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      if (!isAuthorized || loading) return;

      setLoading(true);
      const next = !active;
      setActive(next);

      try {
        const result = await api.toggleFavorite(itemId);
        const isActive = result?.isActive ?? next;
        setActive(isActive);
        onChange?.(itemId, isActive);
      } catch {
        setActive(!next);
      } finally {
        setLoading(false);
      }
    },
    [api, active, isAuthorized, itemId, loading, onChange],
  );

  return { active, loading, isAuthorized, handleClick };
};